import { useApi } from '@/api';
import { Flex, KpiSkeleton, KpiCard } from '@blockanalitica/ui';

type AtRiskResponse = {
  at_10_drop: number;
  at_20_drop: number;
  at_30_drop: number;
  at_40_drop: number;
};

export default function Kpis() {
  const [data, error] = useApi<AtRiskResponse>({
    url: '/at-risk/collateral/'
  });

  if (error) {
    throw error;
  }

  if (!data) {
    return <KpiSkeleton />;
  }

  return (
    <Flex flexDirection={['column', 'row']} gap={['m', 's']}>
      <KpiCard
        title="Liquidated at 10% drop"
        data={data}
        field="drop_10"
        options={{
          valueOptions: {
            currencyValueOptions: {
              currency: 'USD',
              notation: 'compact'
            }
          }
        }}
      />

      <KpiCard
        title="Liquidated at 20% drop"
        data={data}
        field="drop_20"
        options={{
          valueOptions: {
            currencyValueOptions: {
              currency: 'USD',
              notation: 'compact'
            }
          }
        }}
      />

      <KpiCard
        title="Liquidated at 30% drop"
        data={data}
        field="drop_30"
        options={{
          valueOptions: {
            currencyValueOptions: {
              currency: 'USD',
              notation: 'compact'
            }
          }
        }}
      />

      <KpiCard
        title="Liquidated at 40% drop"
        data={data}
        field="drop_40"
        options={{
          valueOptions: {
            currencyValueOptions: {
              currency: 'USD',
              notation: 'compact'
            }
          }
        }}
      />
    </Flex>
  );
}
